/**
 * Copy of the Knowledge tab on the vendor page (ALC-4557) and of the coded refusals of the vendor
 * knowledge API (`errors.<CODE>`, ALC-4551). Sentence case, in the owner's words.
 */
export const vendorKnowledgePtBr = {
  tab: {
    noEntities: 'Nenhuma entidade disponível para mostrar as regras.',
    sectionsLabel: 'Seções das regras',
    sections: {
      classification: 'Classificação fiscal',
      rules: 'Regras fiscais',
      instructions: 'Instruções',
      workflows: 'Fluxos',
      dismissals: 'Ofertas dispensadas',
    },
    readOnlyNotice:
      'Você pode ver as regras, as instruções e as ofertas dispensadas, mas não mudá-las. Para criar ou editar, é preciso a permissão "Conhecimento de fornecedores".',
    loadErrorTitle: 'Não foi possível carregar o conhecimento',
    loadErrorDescription: 'Tente de novo. Se continuar, avise o suporte.',
  },
  common: {
    retry: 'Tentar de novo',
    cancel: 'Cancelar',
    readOnly: 'Somente leitura',
    competence: 'Vale a partir da competência',
    competencePlaceholder: 'Escolha a competência',
    unknownServiceType: 'Tipo de serviço não disponível',
    taxName: {
      IRRF: 'IRRF',
      PIS: 'PIS',
      COFINS: 'COFINS',
      CSLL: 'CSLL',
      INSS: 'INSS',
      ISS: 'ISS',
    },
  },
  classification: {
    title: 'Classificação fiscal',
    description:
      'Valores padrão deste fornecedor, usados como ponto de partida nas contas a pagar. Valem para todas as entidades.',
    defaultCfop: 'CFOP padrão',
    defaultNcm: 'NCM padrão',
    defaultCstIcms: 'CST ICMS padrão',
    defaultCstIpi: 'CST IPI padrão',
    defaultCstPis: 'CST PIS padrão',
    defaultCstCofins: 'CST COFINS padrão',
    notSet: 'Não definido',
    edit: 'Editar',
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    saved: 'Classificação fiscal salva',
    saveError: 'Não foi possível salvar a classificação fiscal. Tente de novo.',
    editLabel: 'Editar a classificação fiscal',
  },
  rules: {
    title: 'Regras fiscais',
    description:
      'Retenção e crédito de PIS/COFINS por tipo de serviço. Cada mudança cria uma versão a partir de uma competência; as anteriores continuam valendo antes dela.',
    new: 'Nova regra',
    label: 'Regras fiscais do fornecedor',
    columns: {
      serviceType: 'Tipo de serviço',
      withholding: 'Retenção',
      credit: 'Crédito PIS/COFINS',
      current: 'Vigente',
    },
    noWithholding: 'Sem regra de retenção',
    taxApplies: '{{tax}} {{rate}}',
    taxAppliesDefaultRate: '{{tax}} (alíquota padrão)',
    taxNotApplies: '{{tax}} não se aplica',
    creditGenerates: 'Gera crédito',
    creditNotGenerates: 'Não gera crédito',
    creditNone: 'Sem regra de crédito',
    since: 'v{{number}} · desde {{from}}',
    inactiveSince: 'Desativada desde {{from}}',
    scheduledFrom: 'Começa em {{from}}',
    versions: 'Versões',
    newVersion: 'Nova versão',
    deactivate: 'Desativar',
    reactivate: 'Reativar',
    history: {
      from: 'v{{number}} · {{from}} em diante',
      range: 'v{{number}} · {{from}} a {{until}}',
      deactivated: 'Desativada',
      withholdingLabel: 'Retenção',
      creditLabel: 'Crédito',
    },
    rowActions: 'Ações da regra',
    empty: {
      title: 'Nenhuma regra fiscal',
      description:
        'Registre se cada imposto é retido nesse tipo de serviço e se a compra gera crédito.',
      descriptionReadOnly: 'Ninguém registrou regras fiscais para este fornecedor nesta entidade.',
    },
  },
  instructions: {
    title: 'Instruções',
    description:
      'Orientações em texto que guiam as sugestões da IA nos campos que nenhuma regra preencheu.',
    new: 'Nova instrução',
    allPurposesTaken: 'Todas as finalidades já têm uma instrução. Edite uma existente.',
    label: 'Instruções sobre o fornecedor',
    columns: {
      purpose: 'Finalidade',
      text: 'Instrução',
      current: 'Vigente',
    },
    purpose: {
      classification_allocation: 'Classificação e rateio',
      document_linking: 'Vínculo de documentos',
    },
    unknownPurpose: 'Finalidade não disponível',
    since: 'desde {{from}}',
    inactiveSince: 'Desativada desde {{from}}',
    scheduledFrom: 'Começa em {{from}}',
    versions: 'Versões',
    history: {
      from: 'v{{number}} · {{from}} em diante',
      range: 'v{{number}} · {{from}} a {{until}}',
      deactivated: 'Desativada',
    },
    edit: 'Editar',
    deactivate: 'Desativar',
    reactivate: 'Reativar',
    rowActions: 'Ações da instrução',
    empty: {
      title: 'Nenhuma instrução',
      description:
        'Escreva como a IA deve classificar, ratear ou vincular documentos deste fornecedor.',
      descriptionReadOnly: 'Ninguém escreveu instruções para este fornecedor nesta entidade.',
    },
  },
  workflows: {
    title: 'Fluxos que envolvem esse fornecedor',
    description: 'Somente leitura. Para mudar um workflow, abra-o no builder.',
    label: 'Tabela de workflows do fornecedor',
    columns: {
      name: 'Workflow',
      trigger: 'Gatilho',
      scope: 'Entidade',
      origin: 'Origem',
      sourceBill: 'Conta de origem',
      created: 'Criada',
      status: 'Status',
      open: 'Builder',
    },
    triggers: {
      bill_intake: 'Conta recebida',
      bill_updated: 'Conta atualizada',
      bill_approved: 'Conta aprovada',
      transaction_accounting_code_updated: 'Conta contábil da transação alterada',
      bill_approval_workflow_init: 'Conta enviada para aprovação',
      bill_reimbursement_policy: 'Política de reembolso',
      purchase_request_policy: 'Política de compras',
      contract_review_version_uploaded: 'Nova versão do contrato',
      contract_review_ai_completed: 'Análise do contrato pela IA concluída',
      contract_review_flags_decided: 'Alertas do contrato decididos',
    },
    allEntities: 'Todas as entidades',
    open: 'Abrir no builder',
    describe: 'Criar a partir de uma descrição',
    openSourceBill: 'Abrir a conta',
    createdBy: 'por {{name}}',
    origin: {
      DESCRIPTION: 'Descrição',
      APPROVAL_OFFER: 'Oferta de aprovação',
    },
    status: {
      DRAFT: 'Rascunho',
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      ARCHIVED: 'Arquivado',
    },
    unknownStatus: 'Status não disponível',
    empty: {
      title: 'Nenhum workflow cita este fornecedor',
      description:
        'Quando um workflow da entidade tiver este fornecedor numa condição, ele aparece aqui.',
    },
    loadError: 'Não foi possível carregar os workflows.',
  },
  dismissals: {
    title: 'Ofertas dispensadas',
    description: 'Valem para toda a entidade. Restaure uma para voltar a receber a sugestão.',
    label: 'Tabela de ofertas dispensadas',
    columns: {
      offer: 'Oferta',
      serviceType: 'Tipo de serviço',
      dismissedAt: 'Dispensada em',
    },
    offerKind: {
      withholding: 'Regra de retenção',
      pis_cofins_credit: 'Regra de crédito PIS/COFINS',
      instruction: 'Instrução',
      reconciliation_rule: 'Regra de conciliação',
      new_service: 'Novo serviço',
      remember: 'Lembrar retenções e créditos',
      approval_automation: 'Regra de aprovação',
    },
    unknownKind: 'Tipo de oferta não disponível',
    anyServiceType: 'Todos os tipos de serviço',
    restore: 'Restaurar',
    restoring: 'Restaurando…',
    restored: 'Oferta restaurada',
    empty: {
      title: 'Nenhuma oferta dispensada',
      description: 'Quando alguém dispensar uma sugestão para este fornecedor, ela aparece aqui.',
    },
    loadError: 'Não foi possível carregar as ofertas dispensadas.',
  },
  ruleSheet: {
    createTitle: 'Regra fiscal',
    versionTitle: 'Nova versão da regra fiscal',
    reactivateTitle: 'Reativar a regra fiscal',
    subtitleNew: '{{vendor}} · {{entity}}',
    versionInfo:
      'Isto cria a versão {{next}} a partir da competência escolhida. A versão {{current}} (desde {{from}}) continua valendo antes dela.',
    reactivateInfo:
      'Reativar é criar uma nova versão numa competência posterior à desativação. Antes dela, a regra continua desativada.',
    serviceTypeLabel: 'Tipo de serviço',
    serviceTypeLockedLabel: 'Fixo',
    serviceTypeLockedHint:
      'Uma nova versão vale para o mesmo tipo de serviço. Para outro, crie uma nova regra.',
    serviceTypePlaceholder: 'Escolha o tipo de serviço',
    serviceTypeIdLabel: 'Identificador do tipo de serviço',
    serviceTypeIdHint:
      'Você não tem acesso à lista de tipos de serviço, então informe o identificador.',
    serviceTypeTaken: 'Esse tipo de serviço já tem uma regra. Use "Nova versão" na linha dele.',
    withholdingTitle: 'Retenção',
    withholdingHint: 'Sem alíquota, vale a alíquota padrão do sistema para o serviço.',
    taxChoice: {
      none: 'Sem regra',
      applies: 'Retém',
      not_applies: 'Não retém',
    },
    taxChoiceLabel: 'Regra para {{tax}}',
    rateLabel: 'Alíquota de {{tax}}',
    ratePlaceholder: 'Padrão',
    creditTitle: 'Crédito PIS/COFINS',
    creditChoiceLabel: 'Esta compra gera crédito?',
    creditChoice: {
      none: 'Sem regra',
      generates: 'Gera crédito',
      not_generates: 'Não gera crédito',
    },
    creditTypeLabel: 'Tipo de crédito',
    creditTypePlaceholder: 'Escolha o tipo',
    creditType: {
      BASIC: 'Compra comum',
      FIXED_ASSET: 'Ativo imobilizado',
    },
    revenueUseLabel: 'Uso da receita',
    revenueUsePlaceholder: 'Escolha o uso',
    issueCreditDetails: 'Para gerar crédito, escolha o tipo de crédito e o uso da receita.',
    validityTitle: 'Vigência',
    systemInfo:
      'Base de cálculo, valor mínimo e acumulação continuam vindo do sistema. A regra só diz se cada imposto se aplica e, se você quiser, a alíquota.',
    issueEmpty: 'Diga o que vale para pelo menos um imposto ou para o crédito.',
    issueRate: 'A alíquota deve ser maior que 0% e no máximo 100%.',
    issueCumulativeCredit:
      'Compra usada só em receita cumulativa não gera crédito de PIS/COFINS. Escolha "Não gera crédito" ou outro uso da receita.',
    issueCreditAfterCutoff:
      'Créditos de PIS/COFINS terminam na competência 12/2026. Escolha uma competência até 12/2026 ou marque "Sem regra" no crédito.',
    issueCompetence: 'Escolha a competência em que a regra passa a valer.',
    issueServiceType: 'Escolha o tipo de serviço.',
    nothingChanged: 'Nada mudou em relação ao que já vale nesta competência.',
    cancel: 'Cancelar',
    saveCreate: 'Salvar regra',
    saveVersion: 'Criar versão {{number}}',
    saveReactivate: 'Reativar regra',
    saving: 'Salvando…',
    saved: 'Regra salva',
    partialFailure:
      'A retenção foi salva, mas o crédito não. {{reason}} Corrija e salve de novo: o que já foi salvo não será repetido.',
    partialFailureCredit:
      'O crédito foi salvo, mas a retenção não. {{reason}} Corrija e salve de novo: o que já foi salvo não será repetido.',
    refusals: {
      VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
        'Não dá para salvar a partir desta competência: o que você tirou da regra seria desativado, e há uma versão ativa a partir de {{competence}} que manteria isso valendo. Escolha uma competência depois de {{competence}}.',
      VENDOR_KNOWLEDGE_VERSION_EXISTS:
        'Não dá para salvar em {{competence}}: o que você tirou da regra seria desativado, e já existe uma versão que começa nessa competência. Escolha uma competência sem versão.',
      versionAtCompetence:
        'Não dá para salvar em {{competence}}: já existe uma versão ativa desta regra que começa nessa competência, e versões não podem ser editadas. Escolha uma competência sem versão.',
    },
  },
  instructionDialog: {
    createTitle: 'Instrução para {{vendor}}',
    editTitle: 'Editar instrução para {{vendor}}',
    reactivateTitle: 'Reativar instrução para {{vendor}}',
    description: '{{entity}} · guia as sugestões da IA nos campos que nenhuma regra preencheu',
    purposeLabel: 'Finalidade',
    purposeClassification: 'Classificação e rateio',
    purposeClassificationHint: 'Categoria, centro de custo e divisão entre centros',
    purposeLinking: 'Vínculo de documentos',
    purposeLinkingHint: 'Como boletos, notas e pedidos se relacionam',
    purposeTaken: 'Já existe uma instrução para esta finalidade',
    allPurposesTaken: 'Todas as finalidades já têm uma instrução. Edite uma existente.',
    textLabel: 'Texto',
    textPlaceholder: 'Ex.: Rateie sempre entre os centros de custo de Operações e Comercial.',
    textCounter: '{{count}} de {{max}}',
    guardrail: 'Instruções nunca mudam se uma conta pode ser enviada automaticamente.',
    issueText: 'Escreva a instrução.',
    issueTextLength: 'A instrução pode ter no máximo {{max}} caracteres.',
    versionInfo:
      'Isto vale a partir da competência escolhida. O texto anterior continua valendo antes dela.',
    cancel: 'Cancelar',
    save: 'Salvar instrução',
    saving: 'Salvando…',
    saved: 'Instrução salva',
  },
  deactivateDialog: {
    ruleTitle: 'Desativar a regra fiscal',
    instructionTitle: 'Desativar a instrução',
    description:
      'A regra deixa de valer a partir da competência escolhida. O histórico fica guardado e você pode reativá-la depois, numa competência posterior.',
    descriptionInstruction:
      'A instrução deixa de valer a partir da competência escolhida. O histórico fica guardado e você pode reativá-la depois, numa competência posterior.',
    competenceLabel: 'Deixa de valer a partir da competência',
    issueCompetence: 'Escolha a competência.',
    cancel: 'Cancelar',
    confirmRule: 'Desativar regra',
    confirmInstruction: 'Desativar instrução',
    doneRule: 'Regra desativada',
    doneInstruction: 'Instrução desativada',
    refusals: {
      VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
        'Não dá para desativar a partir desta competência: há uma versão ativa a partir de {{competence}} e ela manteria o item valendo. Escolha uma competência depois de {{competence}}.',
      VENDOR_KNOWLEDGE_VERSION_EXISTS:
        'Não dá para desativar em {{competence}}: já existe uma versão que começa nessa competência. Escolha uma competência sem versão.',
    },
  },
  errors: {
    VENDOR_KNOWLEDGE_INVALID_PAYLOAD:
      'Os dados informados não são válidos. Confira os campos e tente de novo.',
    VENDOR_KNOWLEDGE_UNKNOWN_KIND: 'Este tipo de conhecimento não existe.',
    VENDOR_KNOWLEDGE_UNKNOWN_OFFER_KIND: 'Este tipo de oferta não existe.',
    VENDOR_KNOWLEDGE_INVALID_DIMENSIONS:
      'O tipo de serviço ou a finalidade informados não servem para este tipo de conhecimento.',
    VENDOR_KNOWLEDGE_INVALID_COMPETENCE: 'Escolha uma competência válida.',
    VENDOR_KNOWLEDGE_VENDOR_NOT_FOUND: 'Não encontramos este fornecedor.',
    VENDOR_KNOWLEDGE_ENTITY_NOT_FOUND: 'Não encontramos esta entidade.',
    VENDOR_KNOWLEDGE_SERVICE_TYPE_NOT_FOUND: 'Não encontramos este tipo de serviço.',
    VENDOR_KNOWLEDGE_NOT_FOUND: 'Este conhecimento não existe mais. Atualize a página.',
    VENDOR_KNOWLEDGE_DISMISSAL_NOT_FOUND:
      'Esta oferta dispensada não existe mais. Atualize a página.',
    VENDOR_KNOWLEDGE_ALREADY_EXISTS:
      'Já existe uma decisão para este tipo de serviço ou finalidade. Crie uma nova versão da existente.',
    VENDOR_KNOWLEDGE_VERSION_EXISTS: 'Já existe uma versão nesta competência. Escolha outra.',
    VENDOR_KNOWLEDGE_ALREADY_INACTIVE: 'Isto já está desativado nesta competência.',
    VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
      'Já existe uma versão ativa numa competência posterior. Escolha uma competência depois dela.',
    VENDOR_KNOWLEDGE_TAX_JURISDICTION_MISMATCH:
      'Regras de impostos brasileiros só valem para entidades no Brasil.',
    VENDOR_KNOWLEDGE_CREDIT_AFTER_CUTOFF:
      'Créditos de PIS/COFINS terminam na competência 12/2026. Escolha uma competência até 12/2026 ou marque "Sem regra" no crédito.',
    fallback: 'Não foi possível concluir. Tente de novo.',
  },
} as const;

type Widen<T> = T extends string ? string : { [K in keyof T]: Widen<T[K]> };

export const vendorKnowledgeEn: Widen<typeof vendorKnowledgePtBr> = {
  tab: {
    noEntities: 'No entity available to show the rules for.',
    sectionsLabel: 'Rules sections',
    sections: {
      classification: 'Fiscal classification',
      rules: 'Fiscal rules',
      instructions: 'Instructions',
      workflows: 'Workflows',
      dismissals: 'Dismissed offers',
    },
    readOnlyNotice:
      'You can view the rules, instructions and dismissed offers, but not change them. To create or edit, you need the "Vendor knowledge" permission.',
    loadErrorTitle: 'Could not load the knowledge',
    loadErrorDescription: 'Try again. If it keeps failing, contact support.',
  },
  common: {
    retry: 'Try again',
    cancel: 'Cancel',
    readOnly: 'Read only',
    competence: 'Applies from competence',
    competencePlaceholder: 'Choose the competence',
    unknownServiceType: 'Service type unavailable',
    taxName: {
      IRRF: 'IRRF (income tax)',
      PIS: 'PIS',
      COFINS: 'COFINS',
      CSLL: 'CSLL (social contribution)',
      INSS: 'INSS (social security)',
      ISS: 'ISS (service tax)',
    },
  },
  classification: {
    title: 'Fiscal classification',
    description:
      'Default values of this vendor, used as the starting point on bills. They apply to every entity.',
    defaultCfop: 'Default CFOP',
    defaultNcm: 'Default NCM',
    defaultCstIcms: 'Default ICMS CST',
    defaultCstIpi: 'Default IPI CST',
    defaultCstPis: 'Default PIS CST',
    defaultCstCofins: 'Default COFINS CST',
    notSet: 'Not set',
    edit: 'Edit',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    saved: 'Fiscal classification saved',
    saveError: 'Could not save the fiscal classification. Try again.',
    editLabel: 'Edit the fiscal classification',
  },
  rules: {
    title: 'Fiscal rules',
    description:
      'Withholding and PIS/COFINS credit by service type. Each change creates a version from a competence; earlier ones keep applying before it.',
    new: 'New rule',
    label: 'Vendor fiscal rules',
    columns: {
      serviceType: 'Service type',
      withholding: 'Withholding',
      credit: 'PIS/COFINS credit',
      current: 'Current',
    },
    noWithholding: 'No withholding rule',
    taxApplies: '{{tax}} {{rate}}',
    taxAppliesDefaultRate: '{{tax}} (default rate)',
    taxNotApplies: '{{tax}} does not apply',
    creditGenerates: 'Generates credit',
    creditNotGenerates: 'Does not generate credit',
    creditNone: 'No credit rule',
    since: 'v{{number}} · since {{from}}',
    inactiveSince: 'Deactivated since {{from}}',
    scheduledFrom: 'Starts {{from}}',
    versions: 'Versions',
    newVersion: 'New version',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    history: {
      from: 'v{{number}} · {{from}} onward',
      range: 'v{{number}} · {{from}} to {{until}}',
      deactivated: 'Deactivated',
      withholdingLabel: 'Withholding',
      creditLabel: 'Credit',
    },
    rowActions: 'Rule actions',
    empty: {
      title: 'No fiscal rules',
      description:
        'Record whether each tax is withheld for this service type and whether the purchase generates credit.',
      descriptionReadOnly: 'No one has recorded fiscal rules for this vendor in this entity.',
    },
  },
  instructions: {
    title: 'Instructions',
    description: 'Written guidance that steers the AI suggestions in fields no rule filled in.',
    new: 'New instruction',
    allPurposesTaken: 'Every purpose already has an instruction. Edit an existing one.',
    label: 'Instructions about the vendor',
    columns: {
      purpose: 'Purpose',
      text: 'Instruction',
      current: 'Current',
    },
    purpose: {
      classification_allocation: 'Classification and allocation',
      document_linking: 'Document linking',
    },
    unknownPurpose: 'Purpose unavailable',
    since: 'since {{from}}',
    inactiveSince: 'Deactivated since {{from}}',
    scheduledFrom: 'Starts {{from}}',
    versions: 'Versions',
    history: {
      from: 'v{{number}} · {{from}} onward',
      range: 'v{{number}} · {{from}} to {{until}}',
      deactivated: 'Deactivated',
    },
    edit: 'Edit',
    deactivate: 'Deactivate',
    reactivate: 'Reactivate',
    rowActions: 'Instruction actions',
    empty: {
      title: 'No instructions',
      description: 'Write how the AI should classify, allocate or link documents for this vendor.',
      descriptionReadOnly: 'No one has written instructions for this vendor in this entity.',
    },
  },
  workflows: {
    title: 'Workflows involving this vendor',
    description: 'Read only. To change a workflow, open it in the builder.',
    label: 'Vendor workflows table',
    columns: {
      name: 'Workflow',
      trigger: 'Trigger',
      scope: 'Entity',
      origin: 'Origin',
      sourceBill: 'Source bill',
      created: 'Created',
      status: 'Status',
      open: 'Builder',
    },
    triggers: {
      bill_intake: 'Bill received',
      bill_updated: 'Bill updated',
      bill_approved: 'Bill approved',
      transaction_accounting_code_updated: 'Transaction account code changed',
      bill_approval_workflow_init: 'Bill sent for approval',
      bill_reimbursement_policy: 'Reimbursement policy',
      purchase_request_policy: 'Purchase policy',
      contract_review_version_uploaded: 'New contract version',
      contract_review_ai_completed: 'AI contract review done',
      contract_review_flags_decided: 'Contract flags decided',
    },
    allEntities: 'All entities',
    open: 'Open in the builder',
    describe: 'Create from a description',
    openSourceBill: 'Open the bill',
    createdBy: 'by {{name}}',
    origin: {
      DESCRIPTION: 'Description',
      APPROVAL_OFFER: 'Approval offer',
    },
    status: {
      DRAFT: 'Draft',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      ARCHIVED: 'Archived',
    },
    unknownStatus: 'Status unavailable',
    empty: {
      title: 'No workflow names this vendor',
      description: 'When an entity workflow uses this vendor in a condition, it shows up here.',
    },
    loadError: 'Could not load the workflows.',
  },
  dismissals: {
    title: 'Dismissed offers',
    description: 'They apply to the whole entity. Restore one to get the suggestion again.',
    label: 'Dismissed offers table',
    columns: {
      offer: 'Offer',
      serviceType: 'Service type',
      dismissedAt: 'Dismissed on',
    },
    offerKind: {
      withholding: 'Withholding rule',
      pis_cofins_credit: 'PIS/COFINS credit rule',
      instruction: 'Instruction',
      reconciliation_rule: 'Reconciliation rule',
      new_service: 'New service',
      remember: 'Remember withholdings and credits',
      approval_automation: 'Approval rule',
    },
    unknownKind: 'Offer type unavailable',
    anyServiceType: 'All service types',
    restore: 'Restore',
    restoring: 'Restoring…',
    restored: 'Offer restored',
    empty: {
      title: 'No dismissed offers',
      description: 'When someone dismisses a suggestion for this vendor, it shows up here.',
    },
    loadError: 'Could not load the dismissed offers.',
  },
  ruleSheet: {
    createTitle: 'Fiscal rule',
    versionTitle: 'New version of the fiscal rule',
    reactivateTitle: 'Reactivate the fiscal rule',
    subtitleNew: '{{vendor}} · {{entity}}',
    versionInfo:
      'This creates version {{next}} from the chosen competence. Version {{current}} (since {{from}}) keeps applying before it.',
    reactivateInfo:
      'Reactivating means creating a new version at a competence after the deactivation. Before it, the rule stays deactivated.',
    serviceTypeLabel: 'Service type',
    serviceTypeLockedLabel: 'Fixed',
    serviceTypeLockedHint:
      'A new version applies to the same service type. For another one, create a new rule.',
    serviceTypePlaceholder: 'Choose the service type',
    serviceTypeIdLabel: 'Service type identifier',
    serviceTypeIdHint: 'You cannot list service types, so enter the identifier.',
    serviceTypeTaken: 'That service type already has a rule. Use "New version" on its row.',
    withholdingTitle: 'Withholding',
    withholdingHint: 'Without a rate, the system default rate for the service applies.',
    taxChoice: {
      none: 'No rule',
      applies: 'Withholds',
      not_applies: 'Does not withhold',
    },
    taxChoiceLabel: 'Rule for {{tax}}',
    rateLabel: '{{tax}} rate',
    ratePlaceholder: 'Default',
    creditTitle: 'PIS/COFINS credit',
    creditChoiceLabel: 'Does this purchase generate credit?',
    creditChoice: {
      none: 'No rule',
      generates: 'Generates credit',
      not_generates: 'Does not generate credit',
    },
    creditTypeLabel: 'Credit type',
    creditTypePlaceholder: 'Choose the type',
    creditType: {
      BASIC: 'Regular purchase',
      FIXED_ASSET: 'Fixed asset',
    },
    revenueUseLabel: 'Revenue use',
    revenueUsePlaceholder: 'Choose the use',
    issueCreditDetails: 'To generate credit, choose the credit type and the revenue use.',
    validityTitle: 'Validity',
    systemInfo:
      'Calculation base, minimum amount and accumulation keep coming from the system. The rule only says whether each tax applies and, if you want, the rate.',
    issueEmpty: 'Say what applies to at least one tax or to the credit.',
    issueRate: 'The rate must be above 0% and at most 100%.',
    issueCumulativeCredit:
      'A purchase used only against cumulative revenue does not generate PIS/COFINS credit. Choose "Does not generate credit" or another revenue use.',
    issueCreditAfterCutoff:
      'PIS/COFINS credits end with the 12/2026 competence. Pick a competence up to 12/2026 or choose "No rule" for the credit.',
    issueCompetence: 'Choose the competence the rule starts to apply.',
    issueServiceType: 'Choose the service type.',
    nothingChanged: 'Nothing changed compared with what already applies in this competence.',
    cancel: 'Cancel',
    saveCreate: 'Save rule',
    saveVersion: 'Create version {{number}}',
    saveReactivate: 'Reactivate rule',
    saving: 'Saving…',
    saved: 'Rule saved',
    partialFailure:
      'Withholding was saved, but the credit was not. {{reason}} Fix it and save again: what was already saved will not be repeated.',
    partialFailureCredit:
      'The credit was saved, but withholding was not. {{reason}} Fix it and save again: what was already saved will not be repeated.',
    refusals: {
      VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
        'It cannot be saved from this competence: what you removed from the rule would be deactivated, and a version is active from {{competence}} that would keep it in force. Choose a competence after {{competence}}.',
      VENDOR_KNOWLEDGE_VERSION_EXISTS:
        'It cannot be saved in {{competence}}: what you removed from the rule would be deactivated, and a version already starts in that competence. Choose a competence without a version.',
      versionAtCompetence:
        'It cannot be saved in {{competence}}: an active version of this rule already starts in that competence, and versions cannot be edited. Choose a competence without a version.',
    },
  },
  instructionDialog: {
    createTitle: 'Instruction for {{vendor}}',
    editTitle: 'Edit instruction for {{vendor}}',
    reactivateTitle: 'Reactivate instruction for {{vendor}}',
    description: '{{entity}} · steers the AI suggestions in fields no rule filled in',
    purposeLabel: 'Purpose',
    purposeClassification: 'Classification and allocation',
    purposeClassificationHint: 'Category, cost center and the split between cost centers',
    purposeLinking: 'Document linking',
    purposeLinkingHint: 'How bank slips, invoices and orders relate',
    purposeTaken: 'An instruction already exists for this purpose',
    allPurposesTaken: 'Every purpose already has an instruction. Edit an existing one.',
    textLabel: 'Text',
    textPlaceholder: 'E.g. Always allocate between the Operations and Sales cost centers.',
    textCounter: '{{count}} of {{max}}',
    guardrail: 'Instructions never change whether a bill can be sent automatically.',
    issueText: 'Write the instruction.',
    issueTextLength: 'The instruction can have at most {{max}} characters.',
    versionInfo:
      'This applies from the chosen competence. The previous text keeps applying before it.',
    cancel: 'Cancel',
    save: 'Save instruction',
    saving: 'Saving…',
    saved: 'Instruction saved',
  },
  deactivateDialog: {
    ruleTitle: 'Deactivate the fiscal rule',
    instructionTitle: 'Deactivate the instruction',
    description:
      'The rule stops applying from the chosen competence. The history is kept and you can reactivate it later, at a later competence.',
    descriptionInstruction:
      'The instruction stops applying from the chosen competence. The history is kept and you can reactivate it later, at a later competence.',
    competenceLabel: 'Stops applying from competence',
    issueCompetence: 'Choose the competence.',
    cancel: 'Cancel',
    confirmRule: 'Deactivate rule',
    confirmInstruction: 'Deactivate instruction',
    doneRule: 'Rule deactivated',
    doneInstruction: 'Instruction deactivated',
    refusals: {
      VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
        'It cannot be deactivated from this competence: a version is active from {{competence}} and would keep the item in force. Choose a competence after {{competence}}.',
      VENDOR_KNOWLEDGE_VERSION_EXISTS:
        'It cannot be deactivated in {{competence}}: a version already starts in that competence. Choose a competence without a version.',
    },
  },
  errors: {
    VENDOR_KNOWLEDGE_INVALID_PAYLOAD: 'The data is not valid. Check the fields and try again.',
    VENDOR_KNOWLEDGE_UNKNOWN_KIND: 'This kind of knowledge does not exist.',
    VENDOR_KNOWLEDGE_UNKNOWN_OFFER_KIND: 'This kind of offer does not exist.',
    VENDOR_KNOWLEDGE_INVALID_DIMENSIONS:
      'The service type or purpose does not fit this kind of knowledge.',
    VENDOR_KNOWLEDGE_INVALID_COMPETENCE: 'Choose a valid competence.',
    VENDOR_KNOWLEDGE_VENDOR_NOT_FOUND: 'We could not find this vendor.',
    VENDOR_KNOWLEDGE_ENTITY_NOT_FOUND: 'We could not find this entity.',
    VENDOR_KNOWLEDGE_SERVICE_TYPE_NOT_FOUND: 'We could not find this service type.',
    VENDOR_KNOWLEDGE_NOT_FOUND: 'This knowledge no longer exists. Refresh the page.',
    VENDOR_KNOWLEDGE_DISMISSAL_NOT_FOUND:
      'This dismissed offer no longer exists. Refresh the page.',
    VENDOR_KNOWLEDGE_ALREADY_EXISTS:
      'A decision already exists for this service type or purpose. Create a new version of the existing one.',
    VENDOR_KNOWLEDGE_VERSION_EXISTS: 'A version already exists in this competence. Choose another.',
    VENDOR_KNOWLEDGE_ALREADY_INACTIVE: 'This is already deactivated in this competence.',
    VENDOR_KNOWLEDGE_LATER_VERSION_EXISTS:
      'A version is already active in a later competence. Choose a competence after it.',
    VENDOR_KNOWLEDGE_TAX_JURISDICTION_MISMATCH:
      'Brazilian tax rules only apply to entities in Brazil.',
    VENDOR_KNOWLEDGE_CREDIT_AFTER_CUTOFF:
      'PIS/COFINS credits end with the 12/2026 competence. Pick a competence up to 12/2026 or choose "No rule" for the credit.',
    fallback: 'Could not complete. Try again.',
  },
};
